import PageHeader from "components/general/Headers/PageHeader";
import PageLoader from "components/general/PageLoader";
import Seo from "components/general/Seo";
import { useGlobalSearchParams } from "expo-router";
import React from "react";
import ItemListing from "screens/ItemListing";
import { useGetCategoryByCategorySlugAndSubCategorySlugQuery, useGetCategoryBySlugQuery } from "store/abcoApi";
import { useIsMobile } from "utils/hooks/useIsMobile";
export default function Page() {
	const [filterValues, setFilterValues] = React.useState({} as any);
	const { subcategory: slug, category: categorySlug } = useGlobalSearchParams();
	const { data: topCategory }: any = useGetCategoryBySlugQuery({ slug: String(categorySlug) }, { skip: !slug });
	const [isGridView, setIsGridView] = React.useState(true);
	const isMobile = useIsMobile();

	const {
		data: category,
		isLoading,
		isFetching,
		isError,
		error,
		currentData,
	}: { data?: any; isLoading: boolean; isFetching: boolean; isError: boolean; error?: any; currentData?: any } = useGetCategoryByCategorySlugAndSubCategorySlugQuery(
		{
			categorySlug: String(categorySlug),
			subCategorySlug: String(slug),
			sortBy: filterValues?.sortBy,
			...filterValues,
		},
		{ skip: !slug },
	);

	function handleFilterChange(value: any) {
		setFilterValues((prevValues: any) => ({
			...prevValues,
			...value,
		}));
	}
	//const { data:category, isLoading, isFetching, isError, error, currentData} = useGetCategoryBySlugQuery({slug: String(slug)});

	if (isFetching && isLoading) {
		return <PageLoader />;
	}

	if (category == null) {
		return;
	}

	return (
		<>
			<Seo title={category?.seoTitle} description={category?.seoDescription} />
			<ItemListing
				withFooter
				totalFoundItems={category.itemCollection.length}
				topCategory={topCategory}
				category={category}
				handleFilterChange={handleFilterChange}
				itemCollection={category.itemCollection}
				isFetchingItems={isFetching}
			>
				<PageHeader title={category?.name} />
			</ItemListing>
		</>
	);
}
